export default "__VITE_ASSET__DvC6nVB2__"